type Scope = 'scope' | 'system';

export function findScopeVariableMatches(
  searchString: string,
  scopes: readonly Scope[] = ['scope'],
): string[] {
  const p = RegExp(`{{(?:${scopes.join('|')}):([^}]+)}}`, 'gm');
  const matchedString: string[] = [];

  if (searchString) {
    let matches: RegExpExecArray | null;
    while ((matches = p.exec(searchString)) !== null) {
      if (matches && matches[1]) {
        matchedString.push(matches[1]);
      }
    }
  }

  return matchedString;
}
